import React from "react";
import { Box, TextField, Typography } from "@mui/material";

function humanizeLabel(key) {
  if (!key) return "";
  return key
    .toString()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function FieldDate({ name, schema = {}, value, onChange }) {
  const description = schema.description;
  const toInputValue = (v) => {
    if (!v) return "";
    // If already a date-only string (YYYY-MM-DD), return as-is to avoid
    // timezone conversions that happen when parsing into a Date.
    if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const handleChange = (e) => {
    const val = e.target.value; // format: yyyy-mm-dd or empty
    if (!val) {
      onChange && onChange(null);
      return;
    }
    const [yyyy, mm, dd] = val.split("-").map(Number);
    // Save as a plain date-only string to avoid timezone offsets on save.
    const yyyyStr = String(yyyy).padStart(4, "0");
    const mmStr = String(mm).padStart(2, "0");
    const ddStr = String(dd).padStart(2, "0");
    onChange && onChange(`${yyyyStr}-${mmStr}-${ddStr}`);
  };

  return (
    <Box mb={1} sx={{ maxWidth: 360 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {humanizeLabel(name)}:
        </Typography>
        <TextField
          type="date"
          value={toInputValue(value)}
          onChange={handleChange}
          variant="outlined"
          size="small"
          inputProps={{ "aria-label": humanizeLabel(name) }}
        />
      </Box>
    </Box>
  );
}
